export default "__VITE_ASSET__E4k51YfM__"